import styled from "styled-components";

export const ListaBeneficioItemsWrapper = styled.div`
    max-height: 320px;
    overflow: auto;
    background-color: #ffffff;
    padding: 5px;
`;

export const BeneficioItemsGrid = styled.div`
    display: grid;
    margin: 0;
    grid-gap: 10px;
    grid-template-columns: 1fr 1fr 1fr 1fr;

`;

export const BeneficioImage = styled.img`
    height: 100%;
    display: block;
    margin: 0 auto;
`;

export const BeneficioItemCard = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 12.5% 45% 20% 10% 12.5%;

    height: 300px;
    overflow: hidden;
    border-radius: 8px;

    width: 100%;
    border: 1px solid #d5d0d0;
    user-select: none;

    position: relative;

    .imgBeneficioItemCard {
        grid-column: 1/3
    }

    .nombreBeneficioItemCard {
        grid-column: 1/3;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .detalleBeneficioItemCard-container {
        grid-column: 1/3;
        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;
        
        transition: transform 300ms;
        transform: translate3d(0, calc(300px - 1.8rem), 0);
        background: rgb(148, 148, 148);

        &:hover {
            transform: translate3d(0, 0, 0);
        }
    }

    .detalleBeneficioItemCard-header {
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        font-weight: bolder;
        background: rgb(125 125 125);
        padding-top: 1.75px;
        padding-bottom: 1.75px;
    }

    .detalleBeneficioItemCard-body {
        color: white;
        overflow-y: auto;
        margin: 5px;
    }

    &:hover {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2), /* Bottom shadow */ 0px -4px 4px rgba(0, 0, 0, 0.2), /* Top shadow */ -4px 0px 4px rgba(0, 0, 0, 0.2), /* Left shadow */ 4px 0px 4px rgba(0, 0, 0, 0.2); /* Right shadow */
    }
`;

export const TableBeneficiosToSolicitarSummary = styled.div`
    max-height: 250px;
    overflow: auto;
    position: relative;

    width: 100%;
    background: white;
    padding: 0;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);


    table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 0;
        font-size: 12px;
    }

    th,
    td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #ddd;
    }

    th {
        background-color: #f1f1f1;
        color: black;
        position: sticky;
        top: 0;
    }

    td:last-child,
    th:last-child {
        text-align: right;
    }

    .total-row {
        font-weight: bold;
        background-color: #f8f9fa;

        position: sticky;
        bottom: 0;
    }

    .total-row td {
        border-top: 2px solid #f1f1f1;
    }

    tr:hover {
        background-color: #faf9f9;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }
`;

export const FirmaConvenioBeneficiosSteps = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 30px;

    
    .column-step1 {
        position: relative;
        background-color: #ddd;
        padding: 20px;
        width: 25%;
        text-align: center;
        border-radius: 8px;
        height: 75px;
        
    }

    .column-step2 {
        position: relative;
        background-color: #ddd;
        padding: 20px;
        width: 75%;
        text-align: center;
        border-radius: 8px;
        height: 75px;
    }

    .step-number {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 24px;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        font-weight: bold;
        background-color: white;
        color: black;
        border-radius: 50%;
        text-align: center;
        border: 1px solid #ccc;
        user-select: none;
    }

`;

export const TableCampanasLineamientos = styled.div`
    max-height: 250px;
    overflow: auto;
    position: relative;

    width: 100%;
    background: white;
    padding: 0;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;


    table {
        border-collapse: collapse;
        width: 100%;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);
        border-radius: 12px;
        overflow: hidden;
        background-color: #fff;
    }

    th, td {
        padding: 12px;
        text-align: center;
        border: 1px solid #e0e0e0;
    }

    thead {
        background-color: #9d9ca3;
        color: #fff;
    }
`;